import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'link-renderer',
    templateUrl: './link-renderer.component.html',
    standalone: true,
    imports: [TranslateModule]
})
export class LinkRendererComponent implements ICellRendererAngularComp {
    public hasReceipt: boolean = false;
    text: string = this.translate.instant("text_view_receipts");
    class: string = '';
    actionButtons: any[] = [];
    params: ICellRendererParams;

    constructor(private translate: TranslateService) { }

    initilize(params: ICellRendererParams) {
        if (params.data) {
            if (params.data.invoice?.invoiceNumber) {
                this.text = params.colDef.cellRendererParams?.text;
            }
            this.hasReceipt = params.data.hasReceipt;
            this.params = params;
        }
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }
    
    onUserAction(action) {
        this.params.data.userAction = action;
        this.params.node.setData(this.params.data);
        this.params.eGridCell.click();
    }
}
